/*
 * @Author: Huangjiajia
 * @Description: 
 * @Date: 2025-02-05 15:05:24
 * @LastEditors: hjj
 * @LastEditTime: 2025-02-05 15:31:30
 * @FilePath: /nanning_wantong/src/main.js
 */
import Vue from 'vue'
import App from './App.vue'

// Vue.config.productionTip = false

//路由
import router from "./router";

//全局样式
import "./style/index.scss";

//elementUI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI, { size: 'small' })  // 全局设置elementui尺寸


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
